import React from 'react';
import './Switch.css';

export function Switch({ label, checked, onChange, className = '', ...props }) {
  return (
    <label className={`ui-switch ${className}`}>
      <input type="checkbox" className="ui-switch__input" checked={checked} onChange={onChange} {...props} />
      <span className="ui-switch__track">
        <span className="ui-switch__thumb" />
      </span>
      {label && <span className="ui-switch__label">{label}</span>}
    </label>
  );
}
